import { useQuery } from '@tanstack/react-query';

import type { ProductListItem } from '@nucleus-commerce/api-client/admin';

import { schedulesApi } from '../api/schedules-api';

import { scheduleKeys } from './schedule-keys';

export interface ProductLookup {
  title: string;
  handle: string;
}

const toLookup = (items: readonly ProductListItem[]) =>
  new Map(items.map((p): [string, ProductLookup] => [p.id, { title: p.title, handle: p.handle }]));

/**
 * Titles and handles of master products whose ids arrived without them (a hand-over in the URL),
 * in batched `?ids=` reads instead of one request per product. Pass a stable list.
 */
export function useProductsByIds(ids: readonly string[]) {
  return useQuery({
    queryKey: scheduleKeys.productsByIds(ids),
    queryFn: () => schedulesApi.productsByIds(ids),
    enabled: ids.length > 0,
    staleTime: 5 * 60_000,
    select: toLookup,
    meta: { silentError: true },
  });
}

/** Every product the lookups have read so far, from the cache (for titles outside the hook). */
export function lookupsInCache(
  data: ReadonlyArray<readonly [unknown, ProductListItem[] | undefined]>,
) {
  return toLookup(data.flatMap(([, items]) => items ?? []));
}
